import { init } from "./State.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { singleton, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Page } from "./Types.fs.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export function Part() {
    return new WebPart$3(init, (_arg, model) => [model, Cmd_none()], view, (_arg_2) => (new PageHeader(0, [])), (_arg_4) => (!isEmpty(_arg_4) ? ((head(_arg_4) === "beratungstermin") ? (isEmpty(tail(_arg_4)) ? (new Page()) : undefined) : undefined) : undefined), (_arg_3) => singleton("beratungstermin"), (_arg_1) => undefined);
}

//# sourceMappingURL=WebPart.fs.js.map
